export default ({ color, fontSize, typography }) => ({
  applyBtn: {
    backgroundColor: `${color.primaryButtonBackground} !important`,
    borderColor: `${color.primaryButtonBackground} !important`,
    color: `${color.primaryButtonText} !important`,
    fontSize: fontSize.small,
    fontFamily: typography.buttonText,
    height: 40,
    width: 76,
    marginLeft: 20,
    '&:hover': {
      backgroundColor: `${color.primaryButtonHover} !important`,
      borderColor: `${color.primaryButtonHover} !important`,
    },
  },
  buttonBar: {
    background: '#fff',
    height: '100%',
    position: 'relative',
    width: '36%',
    justifyContent: 'space-around',
    display: 'flex',
    alignItems: 'center',
    border: 2,
    borderLeft: `1px solid ${color.borderColor}`,
  },
  textInput: {
    width: 80,
    height: 40,
    display: 'inline-block',
    '& input': {
      borderBottom: 0,
      height: 39,
      width: '100%',
    },
    '&:hover div': {
      borderColor: '#c8d1e0',
    },
  },
  invalidTextInput: {
    '& input': {
      borderColor: color.borderColorError,
    },
    '&:focus div': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.borderColorError}`,
    },
    '& input:focus + div': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.borderColorError}`,
    },
    '& div': {
      borderColor: color.borderColorError,
    },
  },
  filterLabel: {
    fontSize: fontSize.small,
  },
  searchBar: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  checkBox: {
    cursor: 'pointer',
    marginBottom: 0,
    fontWeight: 'normal',
    display: 'flex',
    alignItems: 'center',
    '& span:last-child': {
      marginLeft: 5,
    },
    '& input + span': {
      display: 'inline-flex',
      paddingLeft: 0,
    },
  },
  cancelBtn: {
    border: `1px solid ${color.primaryButtonBackground}`,
    borderRadius: 4,
    height: '40px!important',
    fontFamily: typography.buttonText,
    width: 75,
    marginLeft: 10,
    background: color.primaryButtonText,
    outline: 'none',
    color: color.primaryButtonBackground,
    fontSize: fontSize.small,
    textDecoration: 'none',
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
  },
  linkBtn: {
    borderColor: '#fff',
    border: 'none',
    height: '40px!important',
    background: 'none',
    outline: 'none',
    display: 'inline',
    color: color.primaryButtonBackground,
    fontSize: fontSize.small,
    textDecoration: 'none',
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
  },
  linkBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: 20,
  },
  filterTypeContainer: {
    borderBottom: '1px solid #D8D8D8',
    paddingLeft: 20,
    paddingTop: 20,
  },
  separatedBtn: {
    marginLeft: 20,
  },
  filterTypeBtn: {
    border: 'none',
    background: '#fff',
    height: 26,
    width: 50,
    padding: 0,
    fontFamily: 'ca-sans-bold',
    fontSize: fontSize.xmedium,
    '&:focus': {
      boxShadow: 'none',
    },
    '& span': {
      padding: 0,
    },
  },
  filterTypeBtnSelected: {
    color: '#09AEEF',
    borderBottom: '2px solid #09AEEF',
    padding: 0,
    paddingBottom: 10,
    borderRadius: 0,
  },
  filterTitle: {
    marginLeft: 20,
    marginTop: 20,
    color: '#2C485C',
    fontFamily: 'ca-sans-bold',
  },
  slots: {
    fontSize: 10,
  },
  removeButton: {
    background: 'rgba(0, 0, 0, 0)',
    border: 0,
    padding: 0,
    textAlign: 'left',
    fontFamily: typography.bodyText,
    letterSpacing: 0,
    color: color.error,
    opacity: 1,
    marginLeft: '1%',
    '&:focus': {
      boxShadow: 'none',
    },
  },
  buttonGroup: {
    display: 'flex',
    alignItems: 'center',
  },
  '@media only screen and (max-width: 1400px)': {
    buttonBar: {
      width: '40%',
    },
  },
  '@media only screen and (max-width: 1170px)': {
    buttonBar: {
      width: '45%',
    },
  },
});